// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1343":"7c36fd3ed2f4a6da","28398":"b6323009d4472833","48846":"6438dbb375600f1b","73527":"38efe5c9e7df8de0"}[chunkId] + ".css";
};